var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "font-normal text-lg rounded p-4 w-full mb-4",
      class: _vm.getBorder,
    },
    [
      _c(
        "p",
        {
          staticClass:
            "font-400 labelWidth leading-6 mb-0.5 text-primary-black text-lg",
        },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
      _vm.institution
        ? _c("CardBodyItem", { staticClass: "mb-0.5" }, [
            _c("p", { staticClass: "text-storm-gray font-400 text-lg" }, [
              _vm._v(_vm._s(_vm.institution)),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex flex-row text-gray-new font-400 text-sm" },
        [
          _vm.startDate
            ? _c("CardBodyItem", {
                staticClass: "mb-0.5",
                attrs: { content: _vm.formattedStartDate },
              })
            : _vm._e(),
          _vm.endDate
            ? _c("span", { staticClass: "px-1 text-gray-new" }, [_vm._v("-")])
            : _vm._e(),
          _vm.endDate
            ? _c("CardBodyItem", {
                staticClass: "mb-0.5",
                attrs: { content: _vm.formattedEndDate },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }